import http from '../axios/http';

export function getPicture(params) {
  return new Promise((resolve, reject) => {
    http.post({
      url: '/captcha/get',
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      success: (data) => {
        resolve(data);
      },
      error: (msg) => {
        reject(new Error(msg));
      }
    });
  });
}

export function reqCheck(params) {
  return new Promise((resolve, reject) => {
    http.post({
      url: '/captcha/check',
      data: params,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      success: (data) => {
        resolve(data);
      },
      error: (msg) => {
        reject(new Error(msg));
      }
    });
  });
}
